module.exports = __webpack_public_path__ + "static/img/Brandon_Ellis_mobile.40dc4e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brandon_Ellis_mobile.jpg
// module id = C4Je
// module chunks = 0